<div class="close-icon" mat-button (click)="dialogRef.close()"></div>
<mat-dialog-content>
  <h3 style="width: 100%; text-align: center;">Category Access Rights</h3>
  <div *ngIf="msg" role="alert" class="alert alert-error alert-dismissible">
    <span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
    <span class="sr-only">Error:</span>
    {{msg}}
  </div>
  <div class="editUser" *ngIf='accessRightsSettings'>
    <p-table [value]="accessRightsSettings"
                 #accessTable
                 [rows]="100"
                 [paginator]="false"
                 [reorderableColumns]="true"
                 sortField="controlItem.userId"
                 dataKey="userId"
                 [metaKeySelection]="false">

      <ng-template pTemplate="header">
        <tr style="white-space: nowrap;font-weight: bold">
          <th style="width:12em">
          </th>
          <th>Allowed categories</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-item let-rowIndex="rowIndex" let-expanded="expanded" let-columns="columns">
        <tr class="ui-widget-header" *ngIf="rowGroupMetadata && rowGroupMetadata[item.userId].index === rowIndex">
          <td colspan="2">
            <a href="#" [pRowToggler]="item">
              <i [ngClass]="expanded ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
              <span>{{item.userName}}</span>
            </a>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="expandedrow" let-item let-rowIndex="rowIndex">
        <tr>
          <td>
                    <span class="ui-inputgroup-addon">
                        <p-checkbox
                          [(ngModel)]="item.isEnabled"

                          binary="true">
                        </p-checkbox>
                    </span>
          </td>
          <td>
            {{item.category}}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <!--alert></alert-->
  <button mat-raised-button [disabled]="loading" style="border-radius: 6px;" (click)="onChange()">Change</button>
  <img *ngIf="loading" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=="/>
  <button mat-raised-button style="border-radius: 6px;" (click)="onClose()">Cancel</button>
</mat-dialog-actions>
